import { Icons } from '@/components/icons';
import { currentYear } from '@/lib/utils';
import { locale } from './locale';

const { constant } = locale;

export const dynamicButtons = {
  becomeMember: {
    buttonText: constant.dynamicButtons.becomeMember,
    buttonLongText: constant.dynamicButtons.becomeMemberLong,
    buttonLink: '/login'
  },
  verifyAccount: {
    buttonText: constant.dynamicButtons.verifyAccount,
    buttonLongText: constant.dynamicButtons.verifyAccountLong,
    // buttonLink: '/complete-profile'
    buttonLink: '/otp-verify?emailType=PERSONAL&email='
  },
  completeProfile: {
    buttonText: constant.dynamicButtons.completeProfile,
    buttonLongText: constant.dynamicButtons.completeProfileLong,
    buttonLink: '/complete-profile'
  },
  // verifyIdentity: {
  //   buttonText: constant.dynamicButtons.verifyWorkEmail,
  //   buttonLongText: constant.dynamicButtons.verifyWorkEmailLong,
  //   buttonLink: '/identity-verify?status=NOT_INITIATED&email='
  // },
  verifyingIdentity: {
    buttonText: constant.dynamicButtons.verifyWorkEmail,
    buttonLongText: constant.dynamicButtons.verifyWorkEmailLong,
    buttonLink: '/identity-verify?status=PENDING&email='
  },
  rejectedIdentity: {
    buttonText: constant.dynamicButtons.rejectedIdentity,
    buttonLongText: constant.dynamicButtons.rejectedIdentityLong,
    buttonLink: '/identity-verify?status=REJECTED&email='
  },
  referAFriend: {
    buttonText: constant.dynamicButtons.referAFriend,
    buttonLongText: constant.dynamicButtons.referAFriendLong,
    buttonLink: '/referral'
  }
};

export const footers = [
  { title: `© ${currentYear} ${constant.footers.title}` },
  { title: constant.footers.about, link: '/about' },
  { title: constant.footers.whatIsIhrhelden, link: '/what-is-ihrHelden' },
  { title: constant.footers.retailersAZ, link: '/retailers' },
  {
    title: constant.footers.partner,
    link: 'https://blog.ihrhelden.de/partner',
    isExternal: true
  },
  { title: constant.footers.imprint, link: '/imprint' },
  { title: constant.footers.contact, link: '/contact' },
  { title: constant.footers.termsAndConditions, link: '/terms-and-conditions' },
  { title: constant.footers.dataProtection, link: '/data-protection' }
  // {
  //   title: constant.footers.cookiePreference,
  //   // link: 'javascript:UC_UI.showSecondLayer();'
  //   link: 'cmpOpen'
  // }
];

export const socialLinks = [
  {
    title: 'Facebook',
    link: 'https://www.facebook.com/profile.php?id=61565206925067',
    Icon: Icons.facebook,
    bgColor: 'bg-black',
    iconProps: { width: 16, height: 16, stroke: '#ffffff', strokeWidth: 1 }
  },
  {
    title: 'Instagram',
    link: 'https://www.instagram.com/ihrhelden',
    Icon: Icons.instagram,
    iconProps: { width: 20, height: 20, strokeWidth: 2 }
  },
  {
    title: 'X',
    link: 'https://x.com/ihrhelden',
    Icon: Icons.x,
    bgColor: 'bg-black',
    iconProps: { width: 16, height: 16, stroke: '#ffffff', strokeWidth: 1 }
  },
  {
    title: 'TikTok',
    link: 'https://www.tiktok.com/@ihrhelden',
    Icon: Icons.tiktok,
    iconProps: { width: 20, height: 20, strokeWidth: 1.5 }
  }
];

// width/height are the files' real intrinsic sizes (they differ per slide) —
// next/image needs them to reserve the right aspect ratio.
export interface DealSlide {
  id: number;
  src: string;
  alt: string;
  width: number;
  height: number;
}

export const originalDeals: DealSlide[] = [
  {
    id: 1,
    src: '/deals/shark-ninja.webp',
    alt: 'Shark Ninja',
    width: 364,
    height: 607
  },
  {
    id: 2,
    src: '/deals/fressnapf.webp',
    alt: 'Fressnapf',
    width: 328,
    height: 568
  },
  {
    id: 3,
    src: '/deals/ernstings-family.webp',
    alt: 'Ernstings Family',
    width: 365,
    height: 593
  },
  {
    id: 4,
    src: '/deals/holy.webp',
    alt: 'HOLY',
    width: 332,
    height: 565
  },
  {
    id: 5,
    src: '/deals/crocs.webp',
    alt: 'Crocs',
    width: 480,
    height: 805
  }
];
